<h1 mat-dialog-title><i class="fad fa-smile"></i>&nbsp;&nbsp; Avalie-nos</h1>
<div mat-dialog-content class="border-top border-bottom pt-3 pb-3">

  <span>De 0 a 10, que nota você daria para o Integrador Contábil?</span><br>
  <div class="w-100 text-center">
    <div class="d-inline-block w-10 text-danger" [ngClass]="{ 'item-selected': selected == 1 }" (click)="selected = 1">
      <i class="cursor-pointer fad fa-2x m-2 fa-meh d-none d-md-inline"></i>
      <br>1
    </div>
    <div class="d-inline-block w-10 text-danger" [ngClass]="{ 'item-selected': selected == 2 }" (click)="selected = 2">
      <i class="cursor-pointer fad fa-2x m-2 fa-meh d-none d-md-inline"></i>
      <br>2
    </div>
    <div class="d-inline-block w-10 text-danger" [ngClass]="{ 'item-selected': selected == 3 }" (click)="selected = 3">
      <i class="cursor-pointer fad fa-2x m-2 fa-meh d-none d-md-inline"></i>
      <br>3
    </div>
    <div class="d-inline-block w-10 text-danger" [ngClass]="{ 'item-selected': selected == 4 }" (click)="selected = 4">
      <i class="cursor-pointer fad fa-2x m-2 fa-meh d-none d-md-inline"></i>
      <br>4
    </div>
    <div class="d-inline-block w-10 text-danger" [ngClass]="{ 'item-selected': selected == 5 }" (click)="selected = 5">
      <i class="cursor-pointer fad fa-2x m-2 fa-meh d-none d-md-inline"></i>
      <br>5
    </div>
    <div class="d-inline-block w-10 text-danger" [ngClass]="{ 'item-selected': selected == 6 }" (click)="selected = 6">
      <i class="cursor-pointer fad fa-2x m-2 fa-meh d-none d-md-inline"></i>
      <br>6
    </div>
    <div class="d-inline-block w-10 text-warning" [ngClass]="{ 'item-selected': selected == 7 }" (click)="selected = 7">
      <i class="cursor-pointer fad fa-2x m-2 fa-meh d-none d-md-inline"></i>
      <br>7
    </div>
    <div class="d-inline-block w-10 text-warning" [ngClass]="{ 'item-selected': selected == 8 }" (click)="selected = 8">
      <i class="cursor-pointer fad fa-2x m-2 fa-meh d-none d-md-inline"></i>
      <br>8
    </div>
    <div class="d-inline-block w-10 text-success" [ngClass]="{ 'item-selected': selected == 9 }" (click)="selected = 9">
      <i class="cursor-pointer fad fa-2x m-2 fa-grin d-none d-md-inline"></i>
      <br>9
    </div>
    <div class="d-inline-block w-10 text-success" [ngClass]="{ 'item-selected': selected == 10 }" (click)="selected = 10">
      <i class="cursor-pointer fad fa-2x m-2 fa-grin-beam d-none d-md-inline"></i>
      <br>10
    </div>
  </div>

  <mat-slider min="1" max="10" step="1" class="w-100 d-block d-md-none" [(ngModel)]="selected"></mat-slider>
  <br><br>

  <span>Ajude-nos, comentando o motivo de sua nota (opcional):</span>
  <textarea class="form-control" [(ngModel)]="observations"></textarea>

</div>
<div mat-dialog-actions class="text-center">
    <div class="container-fluid px-0 py-3 justify-content-between">
      <button class="btn btn-light text-danger mx-2" mat-dialog-close>Responder mais tarde</button>
      <button class="btn btn-primary text-light mx-2" [disabled]="!selected" (click)="confirm()">Enviar</button>
    </div>
</div>
